import { css } from 'react-emotion';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import pickBy from 'lodash/pickBy';

import validate from './validate';
import StepTitle from '../../../common/StepTitle';
import SkuSelectorField from './SkuSelectorField';
import { auth } from '../../../../utils/auth';
import { getListPriceStatuses } from '../../../../services/ProductPrice';
import ListPriceSkuCard from './ListPriceSkuCard';
import Button from '../../../common/Button';
import { withTranslation } from 'react-i18next';

const prevButtonStyle = css({
  float: 'left'
});

const nextButtonStyle = css({
  float: 'right'
});

const divStyle = css({
  marginBottom: '50px'
});

class AddProductsStep extends Component {
  static propTypes = {
    onPrev: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    seller: PropTypes.object.isRequired
  };

  onBulkAddSkus = async skuMap => {
    const { seller } = this.props;
    const skusFromSearch = Object.keys(skuMap);

    const { listPriceStatuses } = await getListPriceStatuses(skusFromSearch, {
      sellerId: seller.id,
      sellerType: seller.type
    });

    const skusWithListPrice = listPriceStatuses.map(listPriceStatus => listPriceStatus.sku);

    skuMap = pickBy(skuMap, skuDetails => skusWithListPrice.includes(skuDetails.sku));

    return skuMap;
  };

  onFetch = async skuMap => {
    const { seller } = this.props;
    const skusFromSearch = Object.keys(skuMap);

    const { listPriceStatuses } = await getListPriceStatuses(skusFromSearch, {
      sellerId: seller.id,
      sellerType: seller.type
    });

    const skusWithListPrice = listPriceStatuses.map(listPriceStatus => listPriceStatus.sku);

    skusWithListPrice.forEach(sku => {
      skuMap[sku].isListPrice = true;
    });

    return skuMap;
  };

  skuCardCustomRenderFn = cardProps => {
    const { skuInfo, shouldExcludeSku, onAddAction } = cardProps;

    return <ListPriceSkuCard skuInfo={skuInfo} shouldExcludeSku={shouldExcludeSku} onAddAction={onAddAction} />;
  };

  render() {
    const { handleSubmit, onPrev, seller, t } = this.props;

    return (
      <div className={divStyle}>
        <StepTitle icon="t-shirt-l" title={t('createContract:addProducts.header')} />
        <Field
          component={SkuSelectorField}
          name="skus"
          sellerId={seller.id}
          onGetAccessToken={auth.getAccessToken}
          onFetch={this.onFetch}
          customOnBulkAddSkus={this.onBulkAddSkus}
          skuCardCustomRenderFn={this.skuCardCustomRenderFn}
          customBulkErrorMessage={t('createContract:addProducts.bulkListPriceErrorMessage')}
        />
        <form onSubmit={handleSubmit}>
          <div>
            <span className={prevButtonStyle}>
              <Button className="btn btn-outline-primary" onClick={onPrev}>
                {t('common:commonWords.prev')}
              </Button>
            </span>
            <span className={nextButtonStyle}>
              <Button className="btn btn-primary">{t('common:commonWords.next')}</Button>
            </span>
          </div>
        </form>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const formSelector = formValueSelector('buyerCreateFlow');

  return {
    seller: formSelector(state, 'seller')
  };
}

AddProductsStep = connect(
  mapStateToProps,
  null
)(withTranslation()(AddProductsStep));

export default reduxForm({
  form: 'buyerCreateFlow',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate
})(AddProductsStep);
